import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Query } from 'apollo-angular';
import { map } from 'rxjs/operators';
import { Article, Category } from '../modules/graphql/generated/graphql-types';
import { ARTICLES_OF_CATEGORY_QUERY, ARTICLE_QUERY } from './queries/article';
import { CmsJsonService } from '../modules/cms-json/services/cms-json.service';

@Injectable({
  providedIn: 'root',
})
export class HelpArticleGQL extends Query<any> {
  document = ARTICLE_QUERY;
}

@Injectable({
  providedIn: 'root',
})
export class HelpArticleOfCategoryGQL extends Query<any> {
  document = ARTICLES_OF_CATEGORY_QUERY;
}

@Injectable({
  providedIn: 'root',
})
export class HelpArticlesService {
  constructor(
    private helpArticleGQL: HelpArticleGQL,
    private helpArticleOfCategoryGQL: HelpArticleOfCategoryGQL,
    private cmsJsonService: CmsJsonService
  ) {}

  getArticle(uid: string, useLocalJson: boolean = false): Observable<Article> {
    // TODO - temp solution to use content instead of strapi
    return useLocalJson
      ? this.cmsJsonService.getArticle(uid)
      : this.helpArticleGQL.watch({ uid }).valueChanges.pipe(map((result) => result?.data?.articles[0]));
  }

  getArticlesOfCategory(categoryUid: string, useLocalJson: boolean = false): Observable<Category> {
    // TODO - temp solution to use content instead of strapi
    return useLocalJson
      ? this.cmsJsonService.getArticlesOfCategory(categoryUid)
      : this.helpArticleOfCategoryGQL
          .watch({ uid: categoryUid })
          .valueChanges.pipe(map((result) => result?.data?.categories[0]));
  }

  getGlobalComponentElement(article: any, contentSectionID: string) {
    return article?.elements?.filter((element) => element.contentSectionID === contentSectionID)[0];
  }

  getGlobalsGenericComponent(article: any, contentSectionID: string, genericElementUid: string) {
    return this.getGenericComponent(this.getGlobalComponentElement(article, contentSectionID), genericElementUid);
  }

  getGenericComponent(globalComponentElement: any, genericElementUid: string) {
    return globalComponentElement?.genericComponent.find((genericElement) => genericElement.uid === genericElementUid);
  }

  getSupportOptionElement(article: any) {
    return article?.elements?.filter((element) => element.support_options)[0];
  }

  getGlobalComponentWithUid(article: any, uid: string) {
    return article?.elements?.filter((element) => element.Uid === uid)[0];
  }
}
